export default __webpack_public_path__ + "static/media/logos-sap.3a78fc41.png";